import { RDKitModuleFull } from './lib';
import { initialise as initialiseBase } from './ts/initialiser';

export { getInstance } from './ts/initialiser';

export { default as Molecule } from './ts/classes/MoleculeFull';
export { MoleculeError } from './utils';

export const initialise = (fileLocation?: string): Promise<void> => {
  return initialiseBase(RDKitModuleFull, fileLocation);
};
